export enum PregnancyDiagnostic {
    POSITIVE = "POSITIVE",
    NEGATIVE = "NEGATIVE"
}
